import FidsPage from "./FidsPage";

export default function FidsCargoPage() {
  return (
    <FidsPage
      terminal="CGO"
      terminalName="KUL — Cargo Terminal"
      terminalLabel="FIDS Cargo"
    />
  );
}
